import { jsx as _jsx } from "react/jsx-runtime";
import Chart from 'react-apexcharts';
function DonutChart(_a) {
    var series = _a.series, labels = _a.labels, colors = _a.colors, width = _a.width;
    var options = {
        chart: { fontFamily: "'Gabarito', sans-serif" },
        labels: labels,
        colors: colors,
        stroke: {
            width: 0
        },
        legend: {
            show: true,
            position: 'right',
            horizontalAlign: 'center',
            offsetY: 60,
            fontSize: '12px',
            fontFamily: "'Gabarito', sans-serif",
            fontWeight: '500',
            formatter: function (seriesName, opts) {
                var value = opts.w.globals.series[opts.seriesIndex];
                return "".concat(seriesName, " (").concat(value, ")");
            }
        },
        dataLabels: {
            style: {
                fontSize: '11px',
                fontWeight: '500'
            }
        },
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: undefined
                    },
                    legend: {
                        position: 'top',
                        offsetY: 0
                    },
                    dataLabels: {
                        style: {
                            fontSize: '9px'
                        }
                    }
                }
            }
        ],
        plotOptions: {
            pie: {
                donut: {
                    labels: {
                        show: false
                    },
                    size: '75%'
                }
            }
        }
    };
    return (_jsx(Chart, { options: options, series: series, type: "donut", width: width, height: 236 }));
}
export default DonutChart;
